export const assignLocationList = "ASSIGN_LOCATION_LIST";
